import { useSessao } from '../../auth/contexto'
import { Carregando } from '../../components/Estados'
import { TEXTOS } from '../../lib/glossario'
import { DadosDaConta } from './DadosDaConta'
import { TrocaDeSenha } from './TrocaDeSenha'

/**
 * "Minha conta": quem eu sou no contrato e como troco a minha senha.
 *
 * A tela existe por duas necessidades que aparecem no MESMO dia em que alguém entra pela primeira
 * vez. A primeira é a senha: toda conta nasce com uma senha provisória escolhida por um
 * administrador, e a troca obrigatória do primeiro acesso é a única oportunidade de mudá-la se não
 * houver esta tela. A segunda é a pergunta que a segregação faz surgir — quem toma um "esta tela
 * não é do seu perfil" precisa de um lugar previsível que explique por quê, em vez de uma mensagem
 * de erro que já sumiu da frente.
 *
 * Nada aqui é consulta à API: tudo vem do `GET /me` que a sessão já carregou. Buscar de novo o que
 * já está em mãos só acrescentaria um estado de carregamento a uma tela instantânea.
 *
 * @returns a tela da própria conta
 */
export function PaginaPerfil() {
  const { usuario, carregando } = useSessao()

  if (carregando || !usuario) {
    return <Carregando />
  }

  return (
    <div className="max-w-4xl space-y-4">
      <header>
        <h1 className="titulo-da-pagina">{TEXTOS.perfil.titulo}</h1>
        <p className="mt-1 max-w-prose text-sm text-slate-600">{TEXTOS.perfil.ajuda}</p>
      </header>

      <DadosDaConta usuario={usuario} />
      <TrocaDeSenha />
    </div>
  )
}
